import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ErrorText, Layout, TrashIcon } from '@utilities';

import styles from './_index.module.scss';

const EditableText = ({
  className,
  clearIcon = <TrashIcon />,
  error,
  isDisabled,
  onChange,
  onClear,
  value,
  ...props
}) => {
  const handleOnChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Layout.Flex.Column className={styles['editable-text-wrapper']} gap="x-small">
      <div
        className={classNames(styles['editable-text'], className, {
          [styles['has-error']]: Boolean(error),
          [styles['is-disabled']]: isDisabled,
        })}
      >
        <div className={styles['editable-text-input-wrapper']}>
          <div className={styles['editable-text-input-value']}>{value}</div>
          <input
            className={styles['editable-text-input']}
            disabled={isDisabled}
            onChange={handleOnChange}
            type="text"
            value={value}
            {...props}
          />
        </div>
        {onClear && (
          <>
            <span className={styles['editable-text-pipe']} />
            <button
              aria-label="Clear input"
              className={styles['editable-text-clear']}
              disabled={isDisabled}
              onClick={onClear}
              tabIndex={-1}
            >
              {clearIcon}
            </button>
          </>
        )}
      </div>
      {error && <ErrorText className={styles['editable-text-error']}>{error}</ErrorText>}
    </Layout.Flex.Column>
  );
};

EditableText.propTypes = {
  className: PropTypes.string,
  clearIcon: PropTypes.node,
  error: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  value: PropTypes.string,
};

export default EditableText;
